
import { Injectable, Injector } from '@angular/core';

import { HelpConfig } from '@config/help-config';
import { CfcModel } from '@core/models/gestao/cfc.model';
import { BaseResourceService } from '@core/services/outros/base-resource.service';
import { HttpClient } from '@microsoft/signalr';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CfcService  extends BaseResourceService<CfcModel> {

  constructor(
    protected injector: Injector,
    private helpConfig: HelpConfig,
  ) {
    super(`${helpConfig.MANAGEMENT_API}cfcs`, injector);
  }

  getByCnpj(cnpj: string): Observable<CfcModel> {
    return this._httpClient.get<CfcModel>(`${this._url}/buscaporcnpj?cnpj=${cnpj}`);
  }

   updateBloqueio(id: number, bloqueado: boolean): Observable<void> {
    const url = `${this._url}/${id}/bloqueio`;
    const params = {
      bloqueado: bloqueado.toString() 
    };
    return this._httpClient.patch<void>(url, null, { params });
  }
}
